<ion-app>
  <ion-router-outlet />
  <ion-loading />
</ion-app>
@if (debugSafeArea) {
  <div class="fixed left-0 right-0 top-0 h-8 select-none bg-purple-500 opacity-25"></div>
  <div class="fixed bottom-0 left-0 right-0 h-8 select-none bg-purple-500 opacity-25"></div>

  <div class="fixed bottom-0 left-0 top-0 w-8 select-none bg-purple-500 opacity-25"></div>
  <div class="fixed bottom-0 right-0 top-0 w-8 select-none bg-purple-500 opacity-25"></div>
}
